module.exports = __webpack_public_path__ + "img/user.9de318e7.png";